import React from 'react';
import './categoriesShopWithNav.css';
import { useRecoilValue } from 'recoil';
import { Label } from '@nooz-optics/nooz-components-lib';
import { IBlock } from '../../../utils/types/contentful';
import { Grid } from '../../UI/Grid/grid';
import { formatContentfulComponentProps } from '../../../utils/globals';
import { collectionState } from '../../../utils/recoil/collection';
import { CategoriesShopNav } from './Nav/CategoriesShopNav';
import { Component } from '../../Contentful/component';
import { FiltersSummary } from './NavForms/Filters/Summary/filterSummary';
import { ShopsWithNavFilters } from 'components/Ecommerce/CategoriesShopWithNav/NavForms/Filters/shopWIthNavFilters';
import clsx from 'clsx';

export interface CategoriesShopWithNavProps {
  categories: IBlock;
  filters: IBlock;
}

const CategoriesShopWithNavLoading = () => (
  <div className='mb-16'>
    <Grid
      grid={{
        gridItems: [
          { path: 'Ecommerce.Shop.LoadingShopItem' },
          { path: 'Ecommerce.Shop.LoadingShopItem' },
          { path: 'Ecommerce.Shop.LoadingShopItem' },
          { path: 'Ecommerce.Shop.LoadingShopItem' },
          { path: 'Ecommerce.Shop.LoadingShopItem' },
          { path: 'Ecommerce.Shop.LoadingShopItem' },
          { path: 'Ecommerce.Shop.LoadingShopItem' },
          { path: 'Ecommerce.Shop.LoadingShopItem' },
        ],
        isSlider: 'hidden',
        gridCols: 'grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
        wrap: true,
      }}
    />
  </div>
);

export const CategoriesShopWithNav: React.FC<CategoriesShopWithNavProps> = (
  props
) => {
  const { content, navigation, emptyStateLabel, hero } = props;
  const collection = useRecoilValue(collectionState);

  const returnCollectionGrid = () => {
    const { resetFilterLabel, filters } = formatContentfulComponentProps(
      navigation
    );

    // Collection search is Active
    if (collection.isActive) {
      if (collection.isLoading) {
        // Loading grid
        return <CategoriesShopWithNavLoading />;
      } else if (collection.grid.gridItems.length === 0) {
        // Empty result
        return (
          <div className='pb-20'>
            <FiltersSummary filters={filters} resetLabel={resetFilterLabel} />
            <Label {...emptyStateLabel} size='2xl' />
          </div>
        );
      } else {
        return (
          <div className='pb-20'>
            <FiltersSummary resetLabel={resetFilterLabel} filters={filters} />
            <Grid
              grid={{
                ...collection.grid,
                isSlider: 'hidden',
                gridCols:
                  'grid-flow-row-dense grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
                wrap: true,
              }}
            />
          </div>
        );
      }
    } else {
      // Return default category page
      return content?.items.map((categorie, index) => {
        // Return intermediary components
        if (categorie.path) {
          return (
            <div
              className={clsx(
                'pb-12 border-gray-400',
                index !== 0 && 'pt-12',
                index !== content?.items.lenght - 1 && 'border-b'
              )}
            >
              <Component {...categorie} />
            </div>
          );
        }
        return (
          <div
            className={clsx(
              'pb-12 border-gray-400',
              index !== 0 && 'pt-12',
              index !== content?.items.length - 1 && 'border-b'
            )}
          >
            <Grid
              grid={{
                ...categorie,
                wrap: true,
                gridCols:
                  'grid-flow-row-dense grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
              }}
            />
          </div>
        );
      });
    }
  };

  const FiltersBody = (
    <div className='w-full px-4 flex-1 overflow-auto'>
      <ShopsWithNavFilters {...formatContentfulComponentProps(navigation)} />
    </div>
  );

  return (
    <div className={'flex items-center flex-col'}>
      {hero ? <Component {...hero} /> : null}
      {navigation ? (
        <CategoriesShopNav
          {...formatContentfulComponentProps(navigation)}
          FiltersBody={FiltersBody}
        />
      ) : null}
      <div className='main-collection-layout relative w-screen px-4 py-4 lg:px-16 xl:px-32'>
        {returnCollectionGrid()}
      </div>
    </div>
  );
};
